const RING_MIN_RADIUS = 30;
const RING_MAX_STRETCH = 60;
const RING_SPACING = 26;
const FOOT_SEPARATION = 26;
const NORTH_ANGLE = -Math.PI / 2;
const EAST_ANGLE = 0;
// Le rayon est dérivé du nombre de points, si bien qu'un anneau taillé sur mesure retombe pile sur
// sa capacité : sans cette tolérance, l'arrondi flottant en rejetterait le dernier point.
const CAPACITY_EPSILON = 1e-9;

// Anneaux concentriques : chacun étale ses points sur la totalité de son pourtour, et son rayon est
// tiré du nombre de points à placer — juste assez large pour les espacer d'un marqueur, sans
// dépasser une extension qui rejetterait un petit groupe trop loin du centre. Ce qui déborde repart
// sur l'anneau suivant, d'où l'escargot des groupes nombreux.
export function spiderfyLegOffsets(count: number): [number, number][] {
  const offsets: [number, number][] = [];
  let remaining = count;
  let minRadius = RING_MIN_RADIUS;

  while (remaining > 0) {
    const fittingRadius = (FOOT_SEPARATION * remaining) / (2 * Math.PI);
    const radius = Math.min(Math.max(minRadius, fittingRadius), minRadius + RING_MAX_STRETCH);
    const capacity = Math.max(1, Math.floor((2 * Math.PI * radius) / FOOT_SEPARATION + CAPACITY_EPSILON));
    const ringCount = Math.min(remaining, capacity);
    // Une paire s'ouvre à l'horizontale : l'un au-dessus de l'autre, les deux marqueurs se liraient
    // comme une file plutôt que comme deux points distincts.
    const startAngle = ringCount === 2 ? EAST_ANGLE : NORTH_ANGLE;

    for (let index = 0; index < ringCount; index++) {
      const angle = startAngle + (2 * Math.PI * index) / ringCount;
      offsets.push([radius * Math.cos(angle), radius * Math.sin(angle)]);
    }

    remaining -= ringCount;
    minRadius = radius + RING_SPACING;
  }

  return offsets;
}
